import React, { useRef, useState } from "react";

// Port of static/scripts/slider.js. Three cross-fading photos, three dots,
// and a swipe gesture on touch devices. The overlay text belongs to the
// middle slide only, which is why that one is the default.
const Slider = ({ images, children }) => {
  const [active, setActive] = useState(1);
  const touchStart = useRef(null);

  const clamp = (index) => Math.max(0, Math.min(images.length - 1, index));

  const handleTouchStart = (event) => {
    const touch = event.touches[0];
    touchStart.current = { x: touch.clientX, y: touch.clientY };
  };

  const handleTouchMove = (event) => {
    if (!touchStart.current) return;

    const touch = event.touches[0];
    const xDiff = touchStart.current.x - touch.clientX;
    const yDiff = touchStart.current.y - touch.clientY;

    // Only treat it as a swipe if the horizontal movement dominates,
    // otherwise a normal vertical scroll would flip the slide.
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      setActive((current) => clamp(current + (xDiff > 0 ? 1 : -1)));
      touchStart.current = null;
    }
  };

  return (
    <div
      className="slider"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <div className="sliderphoto">
        {images.map((image, index) => (
          <img
            key={image.src}
            src={image.src}
            className={`photo${index === active ? " is-active" : ""}`}
            width={1920}
            alt={image.alt}
            // The first slide is the LCP element, so it must not be lazy.
            loading={index === 1 ? "eager" : "lazy"}
          />
        ))}
      </div>
      <div className="slider-sale-and-text">
        {children}
        <div className="rectangles">
          {images.map((image, index) => (
            <div
              key={`dot-${image.src}`}
              className={`rectangle${index === active ? " is-active" : ""}`}
              role="button"
              tabIndex={0}
              aria-label={`Zobrazit fotku ${index + 1}`}
              onClick={() => setActive(index)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setActive(index);
                }
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
